import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import consola from 'consola';
import { uuid } from 'vue-uuid';
import autologinMutation from '@/graphql/user/authentication/autologin.gql';
import logoutUserMutation from '@/graphql/user/authentication/logoutUser.gql';
import signUpCustomerMutation from '@/graphql/user/authentication/signUpCustomer.gql';
import getAfterSalesEligibilityMutation from '@/graphql/user/getAfterSalesEligibility.gql';
import getAfterSalesLinkMutation from '@/graphql/user/getAfterSalesLink.gql';
import specialConditions from '@/graphql/user/propositions/specialConditions.gql';
import userLogin from '@/graphql/user/userLogin.gql';
import { logError } from '@/helpers/log-helper';
import addressesQuery from '~/graphql/user/address/addresses.gql';
import createUserAddressQuery from '~/graphql/user/address/createUserAddress.gql';
import deleteUserAddressQuery from '~/graphql/user/address/deleteUserAddress.gql';
import updateUserAddressMutation from '~/graphql/user/address/updateUserAddress.gql';
import addressValidationQuery from '~/graphql/user/addressValidation.gql';
import refreshTokenMutation from '~/graphql/user/authentication/refreshToken.gql';
import updateUserTokenMutation from '~/graphql/user/authentication/updateUserToken.gql';
import discountsQuery from '~/graphql/user/discounts.gql';
import generateOrderFormReceiptMutation from '~/graphql/user/generateOrderFormReceipt.gql';
import userQuery from '~/graphql/user/me.gql';
import subscribeToNewsletterMutation from '~/graphql/user/newsletter.gql';
import orderQuery from '~/graphql/user/order.gql';
import orderFormQuery from '~/graphql/user/orderForm.gql';
import orderFormsQuery from '~/graphql/user/orderForms.gql';
import ordersQuery from '~/graphql/user/orders.gql';
import profileQuery from '~/graphql/user/profile.gql';
import updateOrderFormMutation from '~/graphql/user/propositions/updateOrderForm.gql';
import updateUserInformationMutation from '~/graphql/user/updateUserInformation.gql';
import updateUserOptinMutation from '~/graphql/user/updateUserOptin.gql';
import updateUserPasswordMutation from '~/graphql/user/updateUserPassword.gql';
import { isValidToken } from '~/helpers/connection-helper';
function loginUser(_x, _x2, _x3) {
  return _loginUser.apply(this, arguments);
}
function _loginUser() {
  _loginUser = _asyncToGenerator(function* (apolloClient, email, password) {
    var response = yield apolloClient.mutate({
      errorPolicy: 'all',
      mutation: userLogin,
      variables: {
        email,
        password
      }
    });
    return response;
  });
  return _loginUser.apply(this, arguments);
}
function autologin(_x4, _x5) {
  return _autologin.apply(this, arguments);
}
function _autologin() {
  _autologin = _asyncToGenerator(function* (apolloClient, token) {
    var response = yield apolloClient.mutate({
      mutation: autologinMutation,
      context: {
        headers: {
          Authorization: "Bearer ".concat(token)
        }
      }
    });
    return response;
  });
  return _autologin.apply(this, arguments);
}
function logoutUser(_x6) {
  return _logoutUser.apply(this, arguments);
}
function _logoutUser() {
  _logoutUser = _asyncToGenerator(function* (context) {
    try {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: logoutUserMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return response.data;
    } catch (e) {
      logError({
        msg: "logoutUser ".concat(e),
        context: this
      });
    }
    return null;
  });
  return _logoutUser.apply(this, arguments);
}
function fetchUser(_x7) {
  return _fetchUser.apply(this, arguments);
}
function _fetchUser() {
  _fetchUser = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      var {
        data
      } = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: userQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return data && data.user;
    }
    return null;
  });
  return _fetchUser.apply(this, arguments);
}
function fetchUserProfile(_x8) {
  return _fetchUserProfile.apply(this, arguments);
}
function _fetchUserProfile() {
  _fetchUserProfile = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      var {
        data
      } = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: profileQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return data && data.user;
    }
    return null;
  });
  return _fetchUserProfile.apply(this, arguments);
}
function fetchUserOrders(_x9, _x10, _x11) {
  return _fetchUserOrders.apply(this, arguments);
}
function _fetchUserOrders() {
  _fetchUserOrders = _asyncToGenerator(function* (context, limit, manageOrdersErrors) {
    if (isValidToken()) {
      var {
        data,
        errors
      } = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'no-cache',
        errorPolicy: manageOrdersErrors ? 'all' : 'none',
        query: ordersQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          limit,
          mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
        }
      });
      if (manageOrdersErrors && errors) {
        consola.error(errors);
      }
      return data && data.orders;
    }
    return null;
  });
  return _fetchUserOrders.apply(this, arguments);
}
function fetchUserOrderForms(_x12, _x13, _x14) {
  return _fetchUserOrderForms.apply(this, arguments);
}
function _fetchUserOrderForms() {
  _fetchUserOrderForms = _asyncToGenerator(function* (context, limit, manageOrdersErrors) {
    if (isValidToken()) {
      var {
        data,
        errors
      } = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'no-cache',
        errorPolicy: manageOrdersErrors ? 'all' : 'none',
        query: orderFormsQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          limit,
          mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
        }
      });
      if (manageOrdersErrors && errors) {
        consola.error(errors);
      }
      return data && data.orderForms;
    }
    return null;
  });
  return _fetchUserOrderForms.apply(this, arguments);
}
function fetchUserOrderForm(_x15, _x16) {
  return _fetchUserOrderForm.apply(this, arguments);
}
function _fetchUserOrderForm() {
  _fetchUserOrderForm = _asyncToGenerator(function* (context, reference) {
    if (isValidToken()) {
      var {
        data
      } = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'no-cache',
        query: orderFormQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          reference,
          mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
        }
      });
      return data && data.orderForm;
    }
    return null;
  });
  return _fetchUserOrderForm.apply(this, arguments);
}
function fetchUserOrder(_x17, _x18) {
  return _fetchUserOrder.apply(this, arguments);
}
function _fetchUserOrder() {
  _fetchUserOrder = _asyncToGenerator(function* (context, reference) {
    if (isValidToken()) {
      var locale = context.state.i18n.currentLocale.iso;
      var response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'no-cache',
        query: orderQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          reference,
          locale,
          mockOrdersEnabled: +localStorage.getItem('MOCK_ORDERS_ENABLED')
        }
      });
      return response.data;
    }
    return null;
  });
  return _fetchUserOrder.apply(this, arguments);
}
function fetchUserOrderReturnLink(_x19, _x20) {
  return _fetchUserOrderReturnLink.apply(this, arguments);
}
function _fetchUserOrderReturnLink() {
  _fetchUserOrderReturnLink = _asyncToGenerator(function* (apolloClient, reference) {
    if (isValidToken()) {
      var _data$getAfterSalesLi;
      var {
        data
      } = yield apolloClient.mutate({
        mutation: getAfterSalesLinkMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          input: {
            reference
          }
        }
      });
      return data === null || data === void 0 ? void 0 : (_data$getAfterSalesLi = data.getAfterSalesLink) === null || _data$getAfterSalesLi === void 0 ? void 0 : _data$getAfterSalesLi.link;
    }
    return null;
  });
  return _fetchUserOrderReturnLink.apply(this, arguments);
}
function fetchUserBLReturnEligibility(_x21, _x22) {
  return _fetchUserBLReturnEligibility.apply(this, arguments);
}
function _fetchUserBLReturnEligibility() {
  _fetchUserBLReturnEligibility = _asyncToGenerator(function* (apolloClient, reference) {
    if (isValidToken()) {
      var _data$getAfterSalesEl;
      var {
        data
      } = yield apolloClient.mutate({
        mutation: getAfterSalesEligibilityMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          input: {
            reference
          }
        }
      });
      return data === null || data === void 0 ? void 0 : (_data$getAfterSalesEl = data.getAfterSalesEligibility) === null || _data$getAfterSalesEl === void 0 ? void 0 : _data$getAfterSalesEl.isEligibleForReturn;
    }
    return null;
  });
  return _fetchUserBLReturnEligibility.apply(this, arguments);
}
function signUpAsCustomer(_x23, _x24, _x25) {
  return _signUpAsCustomer.apply(this, arguments);
}
function _signUpAsCustomer() {
  _signUpAsCustomer = _asyncToGenerator(function* (context, form, recaptchaToken) {
    var response = yield context.mutate({
      errorPolicy: 'all',
      mutation: signUpCustomerMutation,
      variables: {
        input: form,
        recaptchaToken
      }
    });
    return response;
  });
  return _signUpAsCustomer.apply(this, arguments);
}
function fetchUserAddresses(_x26) {
  return _fetchUserAddresses.apply(this, arguments);
}
function _fetchUserAddresses() {
  _fetchUserAddresses = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: addressesQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return response.data;
    }
    return null;
  });
  return _fetchUserAddresses.apply(this, arguments);
}
function deleteUserAddress(_x27, _x28, _x29, _x30) {
  return _deleteUserAddress.apply(this, arguments);
}
function _deleteUserAddress() {
  _deleteUserAddress = _asyncToGenerator(function* (context, addressId, addressType, addressAlias) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: deleteUserAddressQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          addressId,
          addressType,
          addressAlias
        }
      });
      return response.data;
    }
    return null;
  });
  return _deleteUserAddress.apply(this, arguments);
}
function createUserAddress(_x31, _x32) {
  return _createUserAddress.apply(this, arguments);
}
function _createUserAddress() {
  _createUserAddress = _asyncToGenerator(function* (context, address) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: createUserAddressQuery,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          address
        }
      });
      return response.data;
    }
    return null;
  });
  return _createUserAddress.apply(this, arguments);
}
function updateUserAddress(_x33, _x34, _x35) {
  return _updateUserAddress.apply(this, arguments);
}
function _updateUserAddress() {
  _updateUserAddress = _asyncToGenerator(function* (context, addressId, address) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserAddressMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          addressId,
          address
        }
      });
      return response.data;
    }
    return null;
  });
  return _updateUserAddress.apply(this, arguments);
}
function updateUserInformation(_x36, _x37) {
  return _updateUserInformation.apply(this, arguments);
}
function _updateUserInformation() {
  _updateUserInformation = _asyncToGenerator(function* (context, user) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserInformationMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          user
        }
      });
      return response.data;
    }
    return null;
  });
  return _updateUserInformation.apply(this, arguments);
}
function updateUserPassword(_x38, _x39, _x40) {
  return _updateUserPassword.apply(this, arguments);
}
function _updateUserPassword() {
  _updateUserPassword = _asyncToGenerator(function* (context, oldPassword, newPassword) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserPasswordMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          oldPassword,
          newPassword
        }
      });
      return response;
    }
    return null;
  });
  return _updateUserPassword.apply(this, arguments);
}
function fetchDiscounts(_x41) {
  return _fetchDiscounts.apply(this, arguments);
}
function _fetchDiscounts() {
  _fetchDiscounts = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      var locale = context.state.i18n.currentLocale.iso;
      var response = yield context.app.apolloProvider.defaultClient.query({
        fetchPolicy: 'network-only',
        query: discountsQuery,
        variables: {
          locale
        },
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return response.data;
    }
    return null;
  });
  return _fetchDiscounts.apply(this, arguments);
}
function updateUserOptin(_x42, _x43, _x44) {
  return _updateUserOptin.apply(this, arguments);
}
function _updateUserOptin() {
  _updateUserOptin = _asyncToGenerator(function* (context, input, addressId) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserOptinMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        },
        variables: {
          input,
          addressId
        }
      });
      return response.data;
    }
    return null;
  });
  return _updateUserOptin.apply(this, arguments);
}
function subscribeToNewsletter(_x45, _x46, _x47) {
  return _subscribeToNewsletter.apply(this, arguments);
}
function _subscribeToNewsletter() {
  _subscribeToNewsletter = _asyncToGenerator(function* (context, email, optIn) {
    var {
      iso: locale
    } = context.state.i18n.currentLocale;
    var response = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: subscribeToNewsletterMutation,
      variables: {
        email,
        optIn,
        locale
      }
    });
    return response.data;
  });
  return _subscribeToNewsletter.apply(this, arguments);
}
function updateUserToken(_x48) {
  return _updateUserToken.apply(this, arguments);
}
function _updateUserToken() {
  _updateUserToken = _asyncToGenerator(function* (context) {
    if (isValidToken()) {
      var response = yield context.app.apolloProvider.defaultClient.mutate({
        mutation: updateUserTokenMutation,
        context: {
          headers: {
            Authorization: "Bearer ".concat(localStorage.getItem('MDM_ACCESS_TOKEN'))
          }
        }
      });
      return response.data;
    }
    return null;
  });
  return _updateUserToken.apply(this, arguments);
}
function refreshToken(_x49) {
  return _refreshToken.apply(this, arguments);
}
function _refreshToken() {
  _refreshToken = _asyncToGenerator(function* (context) {
    var response = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: refreshTokenMutation,
      context: {}
    });
    return response.data;
  });
  return _refreshToken.apply(this, arguments);
}
function fetchSpecialConditions(_x50, _x51) {
  return _fetchSpecialConditions.apply(this, arguments);
}
function _fetchSpecialConditions() {
  _fetchSpecialConditions = _asyncToGenerator(function* (defaultClient, maskedQuoteId) {
    var response = yield defaultClient.mutate({
      mutation: specialConditions,
      variables: {
        maskedQuoteId
      }
    });
    return response.data;
  });
  return _fetchSpecialConditions.apply(this, arguments);
}
function generateOrderFormReceipt(_x52, _x53) {
  return _generateOrderFormReceipt.apply(this, arguments);
}
function _generateOrderFormReceipt() {
  _generateOrderFormReceipt = _asyncToGenerator(function* (context, _ref) {
    var {
      maskedQuoteId,
      shopId,
      uid,
      token
    } = _ref;
    var response = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: generateOrderFormReceiptMutation,
      context: {
        headers: {
          Authorization: "Bearer ".concat(token)
        }
      },
      variables: {
        input: {
          cartId: maskedQuoteId,
          shopId,
          sellerId: uid
        }
      }
    });
    return response;
  });
  return _generateOrderFormReceipt.apply(this, arguments);
}
function fetchFeatures(_x54) {
  return _fetchFeatures.apply(this, arguments);
}
function _fetchFeatures() {
  _fetchFeatures = _asyncToGenerator(function* (_ref2) {
    var {
      market,
      locale,
      logger,
      sellerContextStoreId
    } = _ref2;
    try {
      var myHeaders = new Headers();
      myHeaders.append('Content-Type', 'application/json');
      if (isValidToken()) {
        myHeaders.append('token', localStorage.getItem('MDM_ACCESS_TOKEN'));
      }
      var myInit = {
        method: 'GET',
        headers: myHeaders
      };
      var myRequest = new Request("".concat(window.location.origin, "/features?market=").concat(market, "&locale=").concat(locale, "&uuid=").concat(uuid.v1(), "&sellerContextStoreId=").concat(sellerContextStoreId), myInit);
      var data = yield fetch(myRequest, myInit);
      return data.json();
    } catch (e) {
      console.error(e);
      logger === null || logger === void 0 ? void 0 : logger.error(e);
    }
  });
  return _fetchFeatures.apply(this, arguments);
}
function updateOrderForm(_x55, _x56) {
  return _updateOrderForm.apply(this, arguments);
}
function _updateOrderForm() {
  _updateOrderForm = _asyncToGenerator(function* (context, _ref3) {
    var {
      maskedQuoteId,
      tokenSeller,
      token
    } = _ref3;
    var response = yield context.app.apolloProvider.defaultClient.mutate({
      mutation: updateOrderFormMutation,
      context: {
        headers: {
          Authorization: "Bearer ".concat(token)
        }
      },
      variables: {
        maskedQuoteId,
        tokenSeller
      }
    });
    return response;
  });
  return _updateOrderForm.apply(this, arguments);
}
function fetchAddressValidation(_x57, _x58) {
  return _fetchAddressValidation.apply(this, arguments);
}
function _fetchAddressValidation() {
  _fetchAddressValidation = _asyncToGenerator(function* (context, _ref4) {
    var {
      streetName,
      country,
      postalCode,
      locality
    } = _ref4;
    var {
      data
    } = yield context.app.apolloProvider.defaultClient.query({
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
      query: addressValidationQuery,
      variables: {
        streetName,
        country,
        postalCode,
        locality
      }
    });
    return data;
  });
  return _fetchAddressValidation.apply(this, arguments);
}
export { fetchFeatures, autologin, createUserAddress, deleteUserAddress, fetchDiscounts, fetchSpecialConditions, fetchUser, fetchUserAddresses, fetchUserOrder, fetchUserOrderReturnLink, fetchUserBLReturnEligibility, fetchUserOrderForm, fetchUserOrderForms, fetchUserOrders, fetchUserProfile, generateOrderFormReceipt, updateOrderForm, loginUser, logoutUser, refreshToken, subscribeToNewsletter, updateUserAddress, updateUserInformation, updateUserOptin, updateUserPassword, updateUserToken, signUpAsCustomer, fetchAddressValidation };